/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactList } from '../../models/contact-list';

export interface ContactGetList$Params {
}

export function contactGetList(http: HttpClient, rootUrl: string, params?: ContactGetList$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactList>> {
  const rb = new RequestBuilder(rootUrl, contactGetList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContactList>;
    })
  );
}

contactGetList.PATH = '/contact/list';
